/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-danger */
import { parse } from 'marked';
import { Flex } from 'antd';
import iconNoData from 'Assets/images/commons/empty-evaluation.svg';

import useCalcualatorAIScore from '../../hooks/useCalcualatorAIScore';
import { ICheckHealthSummaryResponse } from '../../hooks/useCheckHealthSummary';

import styles from './Content.less';

const renderScore = (score: number) => ` ${score} / 100`;

const renderMarkdown = (text: string) => {
  const html = parse(text ?? '') as string;
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

interface IContentProps {
  evaluation: ICheckHealthSummaryResponse;
}

const SUMMARIES = {
  chiefComplaintAndHistoryOfPresentIllness: 'Chief Complaint & History of Present Illness',
  pastMedicalHistory: 'Past Medical History',
  allergiesAndAdverseDrugReactions: 'Allergies & Adverse Drug Reactions',
  physicalVisualFindings: 'Physical / Visual Findings',
  assessment: 'Assessment',
  planOfCare: 'Plan of Care',
  followUpInstructions: 'Follow-Up Instructions',
};

const SUPPLEMENTAL_HIGHLIGHTS = {
  currentPastMedications: 'Current/Past Medications',
  problemList: 'Problem List',
  reviewOfSystems: 'Review of Systems',
  socialAndFamilyHistory: 'Social and Family History',
};

const EvaluationContent = ({ evaluation }: IContentProps) => {
  const { score, summary } = evaluation ?? {};

  const { scoreLabel } = useCalcualatorAIScore(score ?? null);

  if (!evaluation || Object.keys(evaluation).length === 0) {
    return (
      <Flex vertical gap={16} justify="center" align="center" className={styles.noData}>
        <img src={iconNoData} alt="No Data" width={126} className={styles.noDataIcon} />
        <div>No Evaluation Available</div>
      </Flex>
    );
  }

  const overallNote = summary?.overallNote ?? {};
  const { supplementalHighlights, commendations, suggestionsForImprovement } = overallNote;
  const isShowSupplementalHighlights = Object.values(supplementalHighlights ?? {}).some(
    highlight => !!highlight,
  );

  return (
    <>
      <div className={styles.title}>Overall Score: {scoreLabel}</div>
      <div className={styles.subTitle}>Score Breakdown:</div>
      <div className={styles.item}>
        <ul>
          {Object.entries(SUMMARIES).map(([key, title]) => (
            <li key={key}>
              <strong>{title}:</strong> {renderScore(evaluation.summary[key]?.score)}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.subTitle}>Commendations:</div>
      <div className={styles.item}>
        <ul>
          {commendations?.map((commendation, index) => (
            <li key={`commendations-${index}`}>{commendation}</li>
          ))}
        </ul>
      </div>
      <div className={styles.subTitle}>Suggestions for Improvement:</div>
      <div className={styles.item}>
        <ul>
          {suggestionsForImprovement?.map((suggestion, index) => (
            <li key={`suggestions-${index}`}>{suggestion}</li>
          ))}
        </ul>
      </div>
      <div className={styles.subTitle}>Detailed Evaluation:</div>
      <strong>Mandatory Elements:</strong>
      <div className={styles.item}>
        <ul>
          {Object.entries(SUMMARIES).map(([key, title]) => (
            <li key={key}>
              <strong>{title}:</strong> <br /> {evaluation.summary[key]?.justification ?? ''}
            </li>
          ))}
        </ul>
      </div>
      {isShowSupplementalHighlights && (
        <>
          <div className={styles.subTitle}>Supplemental Highlights:</div>
          <div className={styles.item}>
            <div>
              {Object.entries(SUPPLEMENTAL_HIGHLIGHTS).map(([key, title]) =>
                supplementalHighlights[key] ? (
                  <div key={key}>
                    <strong>{title}:</strong> {renderMarkdown(supplementalHighlights[key] ?? '---')}
                  </div>
                ) : null,
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EvaluationContent;
